import { queryOptions, useQuery } from '@tanstack/react-query';
import { useFlags } from 'launchdarkly-react-client-sdk';

import type { LdFeatureFlags } from '@/config/features';
import useUserPid from '@/features/auth/hooks/use-user-pid';
import type { UserPid } from '@/features/auth/services/oidc';
import { getVerificationInformationSumsubToken, getVerificationInformationSumsubTokenV2 } from '@/services/api/profile';

const profileVerificationSumsubTokenQueryKey = (pid: UserPid, version?: string) => ['profile', 'verification-information-sumsub-token', pid, ...(version ? [version] : [])];

const profileVerificationSumsubTokenQueryOptions = (pid: UserPid, version = 'v1') =>
  queryOptions({
    enabled: !!pid,
    gcTime: 0,
    staleTime: 0,
    queryFn: version === 'v1' ? getVerificationInformationSumsubToken : getVerificationInformationSumsubTokenV2,
    queryKey: profileVerificationSumsubTokenQueryKey(pid, version),
  });

const useProfileVerificationSumsubToken = () => {
  const { pid } = useUserPid();
  const { nciPriorityFlowEnabled } = useFlags<LdFeatureFlags>();

  return useQuery(profileVerificationSumsubTokenQueryOptions(pid, nciPriorityFlowEnabled ? 'v2' : 'v1'));
};

export { profileVerificationSumsubTokenQueryKey, useProfileVerificationSumsubToken };
